module.exports = __webpack_public_path__ + "img/forest.82e68667.svg";